// extracted by mini-css-extract-plugin
export default {"textContainer":"bodytext_textContainer__5kqlP","hoursList":"bodytext_hoursList__NxmQV"};